// extracted by mini-css-extract-plugin
export var option = "_kg-0";
export var optionCard = "_kg-f";
export var optionContent = "_kg-g";
export var optionIcon = "_kg-i";
export var optionIconBox = "_kg-h";
export var optionLabel = "_kg-j";
export var optionPill = "_kg-m";
export var optionPillBadge = "_kg-p";
export var optionPillIcon = "_kg-n";
export var optionPillLabel = "_kg-o";
export var optionRadio = "_kg-k";
export var optionRadioInner = "_kg-l";
export var optionReveal = "_kg-2";
export var optionRevealDelay0 = "_kg-3";
export var optionRevealDelay1 = "_kg-4";
export var optionRevealDelay10 = "_kg-d";
export var optionRevealDelay11 = "_kg-e";
export var optionRevealDelay2 = "_kg-5";
export var optionRevealDelay3 = "_kg-6";
export var optionRevealDelay4 = "_kg-7";
export var optionRevealDelay5 = "_kg-8";
export var optionRevealDelay6 = "_kg-9";
export var optionRevealDelay7 = "_kg-a";
export var optionRevealDelay8 = "_kg-b";
export var optionRevealDelay9 = "_kg-c";
export var optionSelected = "_kg-1";